import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {CommonService} from '@app/feature/store-editor/services/common.service';

@Component({
  selector: 'app-video-setting',
  templateUrl: './video-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class VideoSettingComponent implements OnInit {

  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
  constructor(private cs: CommonService) { }

  ngOnInit() {
  }

  onChange() {
    this.cs.isItUpdated();
  }
}
